import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/verdegro.webp';
import screenshot_target from '../../../images/letterfunnel/gerritverwijs.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Gerrit Verwijs"
      firstname="Gerrit"
      companyname="Verdegro"
      competition="EBO van Weel en Stuer-Egghe"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/gerritverwijs.js